import {IcnEye, IcnEyeOff} from "../../assets/icons";

import React, {HTMLProps, useState} from "react";
import clsx from "clsx"
import {useField} from "formik"

import {cFormGroupProps} from "../../utils";

import FormGroup from "./FormGroup";
import Button from "../common/Button";

interface FormInputProps extends cFormGroupProps, HTMLProps<HTMLInputElement>{
  name: string;
  placeholder?: string;
}

function FormInputPasswordShowHide(
  {
    extraClassName,
    formGroupStyle,
    labelText,
    labelIsHidden,
    name,
    placeholder,
    helpText,
    hideError,
    ...rest
  }: FormInputProps) {

  const [field, meta] = useField(name)
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setShowPassword(false);
    // Call Formik's original blur handler
    field.onBlur(e);
  };

  return (

    <FormGroup
      extraClassName={clsx(`c-form-group-password`, extraClassName && extraClassName)}
      formGroupStyle={formGroupStyle}
      name={name}
      labelText={labelText}
      labelIsHidden={labelIsHidden}
      formGroupExtraContent={
        <Button
          extraClassName="c-form-show-hide-password-btn"
          btnColor="ghost"
          btnVariant='icon'
          title={showPassword? "Hide password": "Show password"}
          icon={showPassword? <IcnEyeOff/>: <IcnEye/>}
          onClick={toggleShowPassword}
        />
      }
      helpText={helpText}
      hideError={hideError}
      hasErrors={meta.touched && meta.error}
      errorText={meta.error}
    >
      <input
        {...field}
        type={showPassword? "text": "password"}
        id={`id_${name}`}
        placeholder={placeholder? placeholder : ""}
        aria-invalid={!!(meta.touched && meta.error)}
        {...rest}
        onBlur={handleBlur}
      />

    </FormGroup>
  )
}

export default FormInputPasswordShowHide